module.exports = __webpack_public_path__ + "media/images/participant-audio-active-792a5964649080ac04644789392d09ea14b8be6785844d9af3c1082247c6ef83.svg";